
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M4.51004 15.48L6.51004 13.89C6.99004 13.51 7.27003 12.93 7.27003 12.32V9.71999C10.29 8.73999 13.56 8.72999 16.59 9.71999V12.33C16.59 12.94 16.87 13.52 17.35 13.9L19.34 15.48C20.14 16.11 21.28 16.05 22 15.33L23.22 14.11C24.02 13.31 24.02 11.98 23.17 11.23C16.76 5.56999 7.10003 5.56999 0.690035 11.23C-0.159965 11.98 -0.159965 13.31 0.640035 14.11L1.86003 15.33C2.57003 16.05 3.71004 16.11 4.51004 15.48Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-call-end`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCallEnd

    ```js
    <b-new-b-icon-call-end />
    ```
</docs>


